import React, { type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

function LibModalNavTip({ children }: Props) {
  return (
    <div className="pt-20 pr-20 pb-20 text-sm text-black-gray">{children}</div>
  );
}

export default LibModalNavTip;
